import { c as _c } from "react/compiler-runtime";
import { DomainActiveRootStatusEnum } from 'modules/profile/mailing-settings/components/domain-verification/enums/domain-active-root-status-enum';
import { DomainVerificationInterface } from 'modules/profile/mailing-settings/components/domain-verification/types/domain-verification-interface';
import { DomainId } from 'modules/profile/mailing-settings/types/mailing-settings-domain-interface';
import { useEffect, useRef } from 'react';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
const VERIFY_DELAY = 5000;
export const useDomainVerification = domainId => {
  const $ = _c(10);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== domainId || $[2] !== user) {
    t1 = () => user && !!domainId && `/api/dashboard/customer/settings/mailing/domain-authentication/${domainId}`;
    $[1] = domainId;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data,
    mutate
  } = useSWR(t1, fetcher);
  const timerRef = useRef(null);
  let t2;
  let t3;
  if ($[4] !== data || $[5] !== mutate) {
    t2 = () => {
      if (!data) {
        return;
      }
      if (data.activeRootPageStatus === DomainActiveRootStatusEnum.pending) {
        timerRef.current = setInterval(() => mutate(), VERIFY_DELAY);
      } else {
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }
      }
      return () => clearInterval(timerRef.current || 0);
    };
    t3 = [data, mutate];
    $[4] = data;
    $[5] = mutate;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  const t4 = data?.activeRootPageStatus;
  let t5;
  if ($[8] !== t4) {
    t5 = {
      status: t4
    };
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};